// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { BorderColorOutlined, InfoOutlined, Star } from "@mui/icons-material";

import Tooltip from "../../../../../../components/Tooltip";
import {
  getEventRequest,
  getEventResponse,
  inviteApplicantsRequest,
} from "../../../../../../store/Events/actions";
import messages from "../../../../../../assets/locale/messages";
import { ROUTE_PATHS } from "../../../../../../utils/RoutesPaths";
import { Alert, Breadcrumbs, TableCell, TableRow } from "@mui/material";
import Filters from "../../../../../../components/Filter";
import Table from "../../../../../../components/Table";
import {
  genders,
  lookupsKeys,
  requestStatuses,
} from "../../../../../../utils/Constants";
import { getEligibleApplicantsRequest } from "../../../../../../store/applicants/actions";
import {
  approveRequest,
  getRequestsRequest,
} from "../../../../../../store/Requests/actions";
import { getLocationsRequest } from "../../../../../../store/Locations/actions";
import RadioButtonsGroup from "../../../../../../components/RadioButton";
import Modal from "../../../../../../components/Modal";
import {
  getCitiesRequest,
  getLookupsRequest,
  getWorkingShiftRequest,
} from "../../../../../../store/Lookups/actions";
import {
  renderTextEllipsis,
  textContainOnlySpaces,
  workHelperShift,
} from "../../../../../../utils/Helpers";
import { UIEmptyState, UIIcon } from "../../../../../../components/ui";
import Checkbox from "../../../../../../components/Checkbox";
import Avatar from "../../../../../../components/Avatar";
import Rate from "../../../../../../components/Rate";
import Select from "../../../../../../components/Select";
import Pagination from "../../../../../../components/Pagination";
import Button from "../../../../../../components/Button";
import "../../../../../../components/RequestsTable/RequestsTable.scss";

const rowsCountOptions = [
  { id: 10, name: "10" },
  { id: 20, name: "20" },
  { id: 30, name: "30" },
  { id: 50, name: "50" },
  { id: 80, name: "80" },
  { id: 100, name: "100" },
];

const isInviteApplicants = true;
const isApplicant = false;

const InviteApplicants = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const event = useSelector((state) => state.events.event);
  const lang = useSelector((state) => state.locale.lang);

  const { events, shared, requests, applicants } = messages[lang];

  useEffect(() => {
    dispatch(getEventRequest(id));

    return () => {
      dispatch(getEventResponse(null));
    };
  }, [id, lang]);

  const breadcrumbsList = [
    {
      path: ROUTE_PATHS.events,
      label: events.listEvents.listEventsBreadcrumb,
    },
    {
      path: event?.status
        ? `${ROUTE_PATHS.events}?tab=${event.status}`
        : ROUTE_PATHS.events,
      label: shared.eventStatusOptions[event?.status],
    },
    {
      path: ROUTE_PATHS.viewEvent.replace(":id", event?.id),
      label: `${event?.name} ${events.listEvents.details}`,
    },
    {
      path: "",
      label: `${events.viewEvents.applicantsTab.inviteApplicants}`,
    },
  ];

  const headLines = [
    shared.select,
    shared.image,
    requests.listRequests.applicantName,
    requests.listRequests.cityOfResidence,
    shared.gender,
    <Tooltip
      key={1}
      title={<p>{events.viewEvents.applicantsTab.hint}</p>}
      content={
        <span>
          {shared.role}
          <span className="px-1">
            <InfoOutlined fontSize="small" />
          </span>
        </span>
      }
    />,
    requests.listRequests.rating,
    applicants.listApplicants.shift,
  ];

  const meta = useSelector((state) => state.applicants.eligibleApplicants.meta);
  const list = useSelector((state) => state.applicants.eligibleApplicants.list);
  const roles = useSelector((state) => state.lookups.general.roles);
  const { cities, workingShift } = useSelector((state) => state.lookups);
  const isLoading = useSelector((state) => state.loader);

  const [rowsCount, setRowsCount] = useState(10);
  const [page, setPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [openWarningApproveModal, setOpenWarningApproveModal] = useState(false);
  const [filterGender, setFilterGender] = useState(null);
  const [filterRequestStatus, setFilterRequestStatus] = useState({
    id: 3,
    name: requests.listRequests.pending,
    value: requestStatuses.notAccepted,
  });
  const [filterRoles, setFilterRoles] = useState(null);
  const [filterRating, setFilterRating] = useState(null);
  const [filterCities, setFilterCities] = useState(null);
  const [singleRole, setSingleRole] = useState(null);
  const [requestId, setRequestId] = useState(null);

  const [selectedApplicants, setSelectedApplicants] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [openRoleModal, setOpenRoleModal] = useState(false);
  const [userName, setUserName] = useState(null);
  const [activeUserId, setActiveUserId] = useState(null);
  const [rolesOptions, setRolesOptions] = useState([]);
  const [originalRole, setOriginalRole] = useState(null);
  const [roleIndex, setRoleIndex] = useState(null);
  const [isRoleSelected, setIsRoleSelected] = useState(false);
  const [selectedRole, setSelectRole] = useState(
    /** @type {{ id: number | string; name: string } | null} */ (null)
  );
  const [autoSelect, setAutoSelect] = useState(false);
  const [shiftSlot, setShiftSlot] = useState([]);
  const [showShiftModal, setShowShiftModal] = useState(false);
  const [selectShift, setSelectShift] = useState(null);
  const [applicantShifts, setApplicantShifts] = useState({});
  const [currentEditingApplicant, setCurrentEditingApplicant] = useState(null);
  const [shiftRole, setShiftRole] = useState(null);


  const statusOptions = [
    { id: 1, name: requests.listRequests.all, value: null },
    {
      id: 2,
      name: requests.listRequests.approved,
      value: requestStatuses.accepted,
    },
    {
      id: 3,
      name: requests.listRequests.pending,
      value: requestStatuses.notAccepted,
    },
    {
      id: 4,
      name: requests.listRequests.cancelled,
      value: requestStatuses.cancelled,
    },
    {
      id: 5,
      name: requests.listRequests.auto_cancelled,
      value: requestStatuses.autoCancelled,
    },
  ];
  const genderOptions = [
    {
      id: 1,
      name: shared.male,
      value: genders.male,
    },
    {
      id: 2,
      name: shared.female,
      value: genders.female,
    },
    {
      id: 3,
      name: shared.notProvided,
      value: genders.notProvided,
    },
  ];
  const ratingOptions = [
    {
      id: 1,
      name: "1",
      value: 1,
      icon: <Star className="rating-star-icon" />,
    },
    {
      id: 2,
      name: "2",
      value: 2,
      icon: <Star className="rating-star-icon" />,
    },
    {
      id: 3,
      name: "3",
      value: 3,
      icon: <Star className="rating-star-icon" />,
    },
    {
      id: 4,
      name: "4",
      value: 4,
      icon: <Star className="rating-star-icon" />,
    },
    {
      id: 5,
      name: "5",
      value: 5,
      icon: <Star className="rating-star-icon" />,
    },
  ];
 

 
const handleEditShift = (applicantId, roleId, roleObj) => {
  setShiftRole(roleObj);
  setCurrentEditingApplicant(applicantId);

  dispatch(getWorkingShiftRequest({ 
    role_id: roleId, 
    event_id: id 
  }));

  const existingShift = applicantShifts[applicantId] || null;
  setSelectShift(existingShift?.id || null);

  setShowShiftModal(true);
};

  useEffect(() => {
    if (!workingShift) return;
    const uniqueShifts = workingShift.reduce((acc, current) => {
      if (!acc.some((shift) => shift.shift_type === current.shift_type)) {
        acc.push(current);
      }
      return acc;
    }, []);

    if (uniqueShifts.length > 0) {
      const uniqueShiftName = uniqueShifts.map((item) => ({
        ...item,
        name:
          shared.shiftTypes?.[item.shift_type] ||
          workHelperShift(item.shift_type) ||
          item.shift_type,
      }));
      setShiftSlot(uniqueShiftName);
    }
  }, [workingShift]);

  useEffect(() => {
    const allRoles = list?.map((applicant) => {
      const previouslySelectedApplicant = selectedApplicants.find(
        (selected) => selected.user_id === applicant.id
      );
      return isInviteApplicants && previouslySelectedApplicant
        ? previouslySelectedApplicant.role
        : applicant.role;
    });
    setSelectedRoles(allRoles);
  }, [!!list?.length, list]);

  const approveRequestHandler = (
    selectedRole,
    requestId,
    acceptableRoles,
    gender
  ) => {
    const selectedRoleData = acceptableRoles?.find(
      (role) => role.role?.id === selectedRole.id
    );
    
    if (
      (selectedRoleData?.maximum_number_of_females <=
        selectedRoleData?.number_of_approved_female_requests &&
        gender == genders.female) ||
      (selectedRoleData?.maximum_number_of_males <=
        selectedRoleData?.number_of_approved_male_requests &&
        gender == genders.male) ||
      (selectedRoleData?.maximum_number_of_males <=
        selectedRoleData?.number_of_approved_male_requests &&
        selectedRoleData?.maximum_number_of_females <=
          selectedRoleData?.number_of_approved_female_requests &&
        gender == genders.notProvided)
    ) {
      setOpenWarningApproveModal(true);
      setRequestId(requestId);
      setSingleRole(selectedRole);
    } else {
      onApproveRequest(selectedRole, requestId);
    }
  };

  const onApproveRequest = (selectedRole, requestId) => {
    let params = {
      role_id: selectedRole.id,
    };
    dispatch(
      approveRequest({
        data: params,
        id: requestId,
        listParams: isApplicant
          ? {
              page: page,
              items: 10,
              // user_id: userId,
              event_name: searchValue,
              status: "pending",
              role_id: filterRoles?.id,
              order_by_created_at: "desc",
              responseType: "requests",
            }
          : {
              page: page,
              items: 10,
              event_and_user_name: searchValue,
              status: filterRequestStatus.value,
              role_id: filterRoles?.id,
              min_user_rating: filterRating?.value,
              max_user_rating: filterRating?.value
                ? filterRating?.value + 0.99
                : null,
              order_by_created_at: "asc",
              responseType: "requests",
              city_id: filterCities?.id,
            },
      })
    );
    handleCloseWarningApproveModal();
  };

  const handleCloseWarningApproveModal = () => {
    setOpenWarningApproveModal(false);
  };

  const getRequests = (
    pageNo,
    search,
    requestStatus,
    role,
    gender,
    rating,
    city
  ) => {
    dispatch(
      isInviteApplicants
        ? getEligibleApplicantsRequest({
            id,
            params: {
              page: pageNo,
              items: rowsCount,
              name: search,
              gender: gender?.value,
              city_id: city?.id,
              role_id: role?.id,
              min_rating: rating?.value,
              max_rating: rating?.value ? rating?.value + 0.99 : null,
            },
          })
        : getRequestsRequest(
            isApplicant
              ? {
                  page: pageNo,
                  items: 10,
                  // user_id: userId,
                  event_name: search,
                  status: "pending",
                  role_id: role?.id,
                  order_by_created_at: "desc",
                  responseType: "requests",
                }
              : {
                  page: pageNo,
                  items: 10,
                  event_and_user_name: search,
                  status: requestStatus?.value,
                  role_id: role?.id,
                  gender: gender?.value,
                  order_by_created_at: "asc",
                  responseType: "requests",
                  min_user_rating: rating?.value,
                  max_user_rating: rating?.value ? rating?.value + 0.99 : null,
                  city_id: city?.id,
                }
          )
    );
  };

  useEffect(() => {
    if (
      (searchValue.length >= 3 || searchValue.length === 0) &&
      !textContainOnlySpaces(searchValue)
    ) {
      setPage(1);
      getRequests(
        1,
        searchValue,
        filterRequestStatus,
        filterRoles,
        filterGender,
        filterRating,
        filterCities
      );
    }
  }, [searchValue]);

  useEffect(() => {
    setPage(1);
    getRequests(
      1,
      searchValue,
      filterRequestStatus,
      filterRoles,
      filterGender,
      filterRating,
      filterCities
    );
  }, [
    filterRequestStatus,
    filterGender,
    filterCities,
    filterRating,
    filterRoles,
    rowsCount,
  ]);

  useEffect(() => {
    getRequests(
      page,
      searchValue,
      filterRequestStatus,
      filterRoles,
      filterGender,
      filterRating,
      filterCities
    );
  }, [page]);

  useEffect(() => {
    dispatch(getLookupsRequest([lookupsKeys.roles]));
    dispatch(
      getCitiesRequest({
        page: -1,
        order_by_name_en: lang === "en" ? "asc" : null,
        order_by_name_ar: lang === "ar" ? "asc" : null,
      })
    );

    getRequests(
      page,
      searchValue,
      filterRequestStatus,
      filterRoles,
      filterGender,
      filterRating,
      filterCities
    );

    if (filterRequestStatus) {
      const localizedFilterValue = statusOptions.find(
        (option) => option.id === filterRequestStatus.id
      );
      setFilterRequestStatus(localizedFilterValue);
    }

    if (filterGender) {
      const localizedFilterValue = genderOptions.find(
        (option) => option.id === filterGender.id
      );
      setFilterGender(localizedFilterValue);
    }
  }, [lang]);

  useEffect(() => {
    if (filterCities) {
      const localizedFilterValue = cities.find(
        (option) => option.id === filterCities.id
      );
      setFilterCities(localizedFilterValue);
    }
  }, [lang, cities]);

  useEffect(() => {
    if (filterRoles) {
      const localizedFilterValue = roles.find(
        (option) => option.id === filterRoles.id
      );
      setFilterRoles(localizedFilterValue);
    }
  }, [lang, roles]);

  useEffect(() => {
    getRequests(
      1,
      searchValue,
      filterRequestStatus,
      filterRoles,
      filterGender,
      filterRating,
      filterCities
    );
  }, [lang]);
  useEffect(() => {
    dispatch(getLocationsRequest());
  }, [dispatch, lang]);

  const onEditRole = ({
    options,
    currentRole,
    applicantId,
    index,
    applicantName,
  }) => {
    setRolesOptions(options);
    setOriginalRole(currentRole);
    setRoleIndex(index);
    setUserName(applicantName);
    setActiveUserId(applicantId);
    setSelectRole(currentRole ?? options?.[0] ?? null);
    setIsRoleSelected(!!(currentRole ?? options?.[0]));
    setOpenRoleModal(true);
  };

  const handleSelectRole = (value, index) => {
    if (value) {
      const selectedRolesCopy = [...selectedRoles];
      selectedRolesCopy[index] = value;
      setSelectedRoles(selectedRolesCopy);
      setSelectRole(value);
      setIsRoleSelected(true);
    }
  };

  const handleCloseRoleModal = (selectedRole) => {
    handleSelectRole(selectedRole || originalRole, roleIndex);
    setOpenRoleModal(false);
    setUserName(null);
    setActiveUserId(null);
    setOriginalRole(null);
    setRolesOptions([]);
    setRoleIndex(null);
    setIsRoleSelected(false);
    setSelectRole(null);
    setAutoSelect(false);
  };
  const renderRolesOptions = () => {
    const radioList = rolesOptions?.map((option) => ({
      value: option?.id,
      label: option?.name,
    }));

    return (
      <RadioButtonsGroup
        id="user-role"
        name="user-role"
        handleChange={(e) => {
          const selectedRole = rolesOptions.find(
            (elt) => elt.id == e.target.value
          );
          handleSelectRole(selectedRole, roleIndex);
        }}
        value={selectedRole?.id}
        listOfRadios={radioList}
      />
    );
  };

  const handleConfirmRole = () => {
    const requestData = list[roleIndex];
    if (isInviteApplicants) {
      handleChangeSelectedApplicantRole();
      handleCloseRoleModal(selectedRoles[roleIndex]);
    } else {
      approveRequestHandler(
        selectedRoles[roleIndex],
        requestData.id,
        requestData.acceptable_roles,
        requestData.user?.gender
      );
      handleCloseRoleModal();
    }
  };

  const handleChangeSelectedApplicantRole = () => {
    const selectedApplicant = selectedApplicants.find(
      (applicant) => applicant.user_id === activeUserId
    );
    const selectedApplicantIndex = selectedApplicants.findIndex(
      (applicant) => applicant.user_id === activeUserId
    );
    // Clear shift when role changes so user must pick a shift for the new role
    setApplicantShifts((prev) => {
      const next = { ...prev };
      delete next[activeUserId];
      return next;
    });
    if (selectedApplicant) {
      const copySelectedApplicantsList = [...selectedApplicants];
      copySelectedApplicantsList.splice(selectedApplicantIndex, 1, {
        ...selectedApplicant,
        role: selectedRoles[roleIndex],
      });
      setSelectedApplicants(copySelectedApplicantsList);
    } else {
      if (autoSelect) handleSelectApplicant(true, activeUserId, roleIndex);
    }
  };

  const handleSelectApplicant = (isSelected, applicantId, applicantIndex) => {
    if (isSelected) {
      const applicantSelectedRole = selectedRoles[applicantIndex];
      setSelectedApplicants([
        ...selectedApplicants,
        {
          user_id: applicantId,
          role: applicantSelectedRole,
        },
      ]);
    } else {
      setSelectedApplicants(
        selectedApplicants.filter(
          (applicant) => applicant.user_id !== applicantId
        )
      );
    }
  };

  const handleInviteApplicants = () => {
    const invitations = selectedApplicants
      .filter(({ role }) => role)
      .map(({ user_id, role }) => ({
        user_id,
        role_id: role.id,
        event_role_shift_id: applicantShifts[user_id]?.id || null,
      }));
    dispatch(
      inviteApplicantsRequest({
        event_id: +id,
        invitations,
      })
    );
  };

  const renderRequestsList = () => {
    if (!isLoading && !list?.length) {
      return (
        <UIEmptyState
          classNames={{
            root: "requests-list-container__empty",
            iconCircle: "requests-list-container__empty-icon-circle",
          }}
          title={
            isInviteApplicants
              ? applicants.listApplicants.noDataDescription
              : requests.listRequests.placeholder
          }
          icon={<UIIcon name="applicantsEmpty" width={40} height={40} />}
        />
      );
    } else {
      return (
        <>
          {isInviteApplicants && (
            <div className="selected-applicants-count text-end">
              <p className="mb-0">
                <span
                  className={`text-light-grey ${
                    lang === "en" ? "me-2" : "ms-2"
                  }`}
                >
                  {shared.selected}
                </span>
                <span
                  className={`${
                    selectedApplicants.length > 50
                      ? "text-warning"
                      : "text-primary-blue"
                  } fweight-500`}
                >
                  {selectedApplicants.length}
                </span>
                <span className="text-light-grey mx-2">{shared.outOf}</span>
                <span className="text-primary-blue fweight-500">{50}</span>
              </p>
            </div>
          )}
          <div className="bg-white rounded-4 mt-2 pb-3">
            <Table
              className="rounded-4"
              headlines={headLines}
              hasActions={false}
              rows={list?.map((row, i) => {
                const acceptableRoles = row.acceptable_roles;
                const currentRole = selectedRoles[i];
                const isRoleAcceptable = !!acceptableRoles.find(
                  (role) => role?.id == currentRole?.id
                );
                return (
                  <TableRow key={i}>
                    {isInviteApplicants && (
                      <TableCell className="select-column">
                        <Checkbox
                          name={row.id}
                          id={row.id}
                          checked={
                            !!selectedApplicants.find(
                              (applicant) => applicant.user_id === row.id
                            )
                          }
                          onChange={(isChecked) => {
                            if (isChecked && !isRoleAcceptable) {
                              setAutoSelect(true);
                              onEditRole({
                                options: row.acceptable_roles,
                                currentRole: selectedRoles[i],
                                index: i,
                                applicantId: row.id,
                                applicantName:
                                  row[
                                    lang === "en"
                                      ? "full_name_en"
                                      : "full_name_ar"
                                  ],
                              });
                            } else {
                              handleSelectApplicant(isChecked, row.id, i);
                            }
                          }}
                          sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }}
                        />
                      </TableCell>
                    )}
                    {!isApplicant && (
                      <TableCell className="avatar-column">
                        <Avatar
                          imgSrc={
                            isInviteApplicants ? row.image : row.user?.image
                          }
                          imgSrcAlt="user-picture"
                          size={30}
                          name={
                            isInviteApplicants
                              ? row.full_name_en
                              : row.user?.full_name_en
                          }
                        />
                      </TableCell>
                    )}
                    {!isApplicant && (
                      <TableCell
                        className={`${
                          (isInviteApplicants
                            ? !row.deleted_at
                            : !row.user?.deleted_at) && "pointer"
                        } mobile-style name-cell`}
                        onClick={() => {
                          if (
                            isInviteApplicants
                              ? !row.deleted_at
                              : !row.user?.deleted_at
                          ) {
                            history.push(
                              ROUTE_PATHS.viewApplicant.replace(
                                ":id",
                                isInviteApplicants ? row.id : row.user?.id
                              )
                            );
                          }
                        }}
                      >
                        {(
                          isInviteApplicants
                            ? row["full_name_" + lang]
                            : row.user?.["full_name_" + lang]
                        )
                          ? renderTextEllipsis(
                              isInviteApplicants
                                ? row["full_name_" + lang]
                                : row.user?.["full_name_" + lang]
                            )
                          : "-"}
                      </TableCell>
                    )}
                    {!isApplicant && (
                      <TableCell className="mobile-style city-cell">
                        {(isInviteApplicants
                          ? row.city?.name
                          : row.user?.city?.name) || "-"}
                      </TableCell>
                    )}
                    {!isApplicant && (
                      <TableCell className="mobile-style">
                        {(isInviteApplicants ? row.gender : row.user.gender)
                          ? shared.genderOptions[
                              isInviteApplicants ? row.gender : row.user.gender
                            ]
                          : "-"}
                      </TableCell>
                    )}
                    <TableCell className="mobile-style role-cell">
                      {(
                        isInviteApplicants
                          ? row.role?.name_en !== "Supervisor"
                          : row.status === "pending" &&
                            row.role?.name_en !== "Supervisor"
                      )
                        ? selectedRoles[i] && (
                            <div className="d-flex align-items-center edit-role-wrapper">
                              <span>{selectedRoles[i]?.name}</span>
                              <BorderColorOutlined
                                className="mx-2 pointer"
                                color={
                                  isInviteApplicants
                                    ? isRoleAcceptable
                                      ? "primary"
                                      : "error"
                                    : "primary"
                                }
                                fontSize="14px"
                                onClick={() =>
                                  onEditRole({
                                    options: row.acceptable_roles,
                                    currentRole: selectedRoles[i],
                                    index: i,
                                    applicantId: isInviteApplicants
                                      ? row.id
                                      : row.user?.id,
                                    applicantName: isInviteApplicants
                                      ? row[
                                          lang === "en"
                                            ? "full_name_en"
                                            : "full_name_ar"
                                        ]
                                      : row.user?.[
                                          lang === "en"
                                            ? "full_name_en"
                                            : "full_name_ar"
                                        ],
                                  })
                                }
                              />
                            </div>
                          )
                        : row.role?.name}
                    </TableCell>
                    {!isApplicant && (
                      <TableCell>
                        {(
                          isInviteApplicants ? row.rating : row.user?.rating
                        ) ? (
                          <div className="MuiDataGrid-cellContent d-flex">
                            <Rate
                              rating={
                                isInviteApplicants
                                  ? row.rating
                                  : row.user?.rating.toFixed(2)
                              }
                            />
                          </div>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    )}
                    {!isApplicant && (
                      <TableCell>
                        {applicantShifts[row.id] ? (
                          <div>
                            {shared.shiftTypes?.[applicantShifts[row.id].shift_type] ||
                              workHelperShift(applicantShifts[row.id].shift_type) ||
                              applicantShifts[row.id].name ||
                              "-"}
                            <BorderColorOutlined
                              fontSize="14px"
                              color={"primary"}
                              className="mx-2 pointer"
                              onClick={() =>
                                handleEditShift(row.id, selectedRoles[i]?.id, selectedRoles[i])
                              }
                            />
                          </div>
                        ) : (
                          <div>
                            <span>{shared.addShift}</span>
                            <BorderColorOutlined
                              fontSize="14px"
                              color={"error"}
                              className="mx-2 pointer"
                              onClick={() =>
                                handleEditShift(row.id, selectedRoles[i]?.id, selectedRoles[i])
                              }
                            />
                          </div>
                        )}
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
            />
          </div>
          <div className="row my-4">
            <div className="col-md-6 col-xl-7 d-flex align-items-center justify-content-end">
              <div
                className={`d-flex justify-content-center ${
                  isInviteApplicants ? "" : "py-3 mt-3"
                }`}
              >
                {meta.pages > 1 && (
                  <Pagination
                    count={meta.pages}
                    page={meta.currentPage || page}
                    handleChange={(event, page) => {
                      setPage(page);
                    }}
                    defaultPage={1}
                  />
                )}
              </div>
            </div>
            <div className="col-md-6 col-xl-5 d-flex align-items-center justify-content-end">
              <div className="rows-count-selection">
                <Select
                  name="rows-count"
                  label={shared.numberOfRows}
                  value={rowsCountOptions.find(
                    (count) => count.id === rowsCount
                  )}
                  onChange={(count) => {
                    setRowsCount(count.id);
                  }}
                  options={rowsCountOptions}
                  wrapperClass={`rows-count-input`}
                  disableClearable={true}
                />
              </div>
            </div>
          </div>

          {isInviteApplicants && (
            <div className="d-flex justify-content-end my-3">
              <div className="d-flex justify-content-end align-items-center invite-btns-container">
                <Button
                  type="button"
                  block
                  label={shared.invite}
                  labelClass="px-4"
                  disabled={
                    selectedApplicants?.length > 50 ||
                    selectedApplicants?.length === 0 ||
                    selectedApplicants.some(
                      (applicant) =>
                        !Object.prototype.hasOwnProperty.call(
                          applicantShifts,
                          applicant.user_id
                        )
                    )
                  }
                  className="mx-2 continue-btn"
                  onClick={handleInviteApplicants}
                />
                <Button
                  onClick={() => {
                    history.push(ROUTE_PATHS.viewEvent.replace(":id", id));
                  }}
                  type="button"
                  block
                  label={shared.cancel}
                  labelClass="px-4"
                  outlined
                  className="mx-2 cancel-btn"
                />
              </div>
            </div>
          )}
          {openRoleModal && (
            <Modal
              open={openRoleModal}
              handleClose={() => handleCloseRoleModal()}
              title={`${requests.listRequests.changeRoleTitle} ${userName}`}
              content={renderRolesOptions()}
              isContentText={false}
              confirmBtnTxt={isInviteApplicants ? shared.save : shared.approve}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              handleCancel={() => handleCloseRoleModal()}
              handleConfirm={handleConfirmRole}
              modalClass="role-select-modal"
              isDisabled={!isRoleSelected}
            />
          )}
          {openWarningApproveModal && (
            <Modal
              open={openWarningApproveModal}
              handleClose={handleCloseWarningApproveModal}
              title={requests.listRequests.warningTitle}
              content={
                <Alert severity="warning" className="fsize-16">
                  {requests.listRequests.warningMessage}
                </Alert>
              }
              isContentText={false}
              confirmBtnTxt={shared.approve}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              handleConfirm={() => onApproveRequest(singleRole, requestId)}
              handleCancel={handleCloseWarningApproveModal}
              modalClass="warning-modal"
              actionsClass="container"
              confirmBtnClass="btn-secondary text-white"
            />
          )}
  
          {showShiftModal && (
            <Modal
              open={showShiftModal}
              handleClose={() => setShowShiftModal(false)}
              title={applicants.listApplicants.addShiftType}
              content={
                <div>
                  {shiftRole?.name && (
                    <div
                      className="d-flex align-items-center mb-3 px-2 py-2 rounded shift-role-info gap-2"
                    >
                      <span className="text-muted small">
                        {applicants.listApplicants.role}
                      </span>
                      <span className="fw-medium">{shiftRole.name}</span>
                    </div>
                  )}
                  {workingShift.length !== 0 ? (
                    <Select
                      name="rows-count"
                      label={applicants.listApplicants.shift}
                      value={shiftSlot.find(
                        (shift) => shift.id === selectShift
                      )}
                      onChange={(s) => setSelectShift(s.id)}
                      options={shiftSlot}
                      wrapperClass={`rows-count-input`}
                      disableClearable={true}
                      autoFocus
                    />
                  ) : (
                    applicants.listApplicants.noShiftFound
                  )}
                </div>
              }
              isContentText={false}
              confirmBtnTxt={workingShift.length === 0 ? null : shared.save}
              isDisabled={workingShift.length !== 0 && !selectShift}
              maxWidth="xs"
              cancelBtnTxt={shared.cancel}
              handleCancel={() => setShowShiftModal(false)}
              handleConfirm={() => {
                if (selectShift && currentEditingApplicant) {
                  const selectedShift = shiftSlot.find(
                    (s) => s.id === selectShift
                  );
                  if (selectedShift) {
                    setApplicantShifts((prev) => ({
                      ...prev,
                      [currentEditingApplicant]: {
                        id: selectedShift.id,
                        shift_type: selectedShift.shift_type,
                        event_row_id: currentEditingApplicant,
                      },
                    }));
                  }
                }
                setShowShiftModal(false);
              }}
              modalClass="role-select-modal"
            />
          )}
        </>
      );
    }
  };

  return (
    <div
      className={`conatiner requests-list-container ${
        isInviteApplicants && "invite-applicants-list-container"
      }`}
    >
      <div className="page-title-margin">
        <Breadcrumbs list={breadcrumbsList} BreadCrumbHasBackIcon={false} />
      </div>
      <Filters
        searchInput={{
          placeholder: "",
          name: "search",
          value: searchValue,
          onChange: (value) => setSearchValue(value),
        }}
        filters={
          isApplicant
            ? [
                {
                  type: "filter",
                  name: "role",
                  placeholder: shared.role,
                  value: filterRoles,
                  options: roles,
                  onChange: (value) => setFilterRoles(value),
                },
              ]
            : isInviteApplicants
            ? [
                {
                  type: "filter",
                  name: "rating",
                  placeholder: requests.listRequests.rating,
                  value: filterRating,
                  options: ratingOptions,
                  isOptionsElt: true,
                  onChange: (value) => setFilterRating(value),
                },
                {
                  type: "filter",
                  name: "gender",
                  placeholder: events.viewEvents.applicantsTab.gender,
                  value: filterGender,
                  options: genderOptions,
                  onChange: (value) => setFilterGender(value),
                },
                {
                  type: "filter",
                  name: "role",
                  placeholder: events.viewEvents.applicantsTab.role,
                  value: filterRoles,
                  options: roles,
                  onChange: (value) => setFilterRoles(value),
                },
                {
                  type: "filter",
                  name: "city",
                  placeholder: requests.listRequests.cityOfResidence,
                  value: filterCities,
                  options: cities,
                  onChange: (value) => setFilterCities(value),
                },
              ]
            : [
                {
                  type: "filter",
                  name: "status",
                  placeholder: requests.listRequests.status,
                  value: filterRequestStatus,
                  options: statusOptions,
                  onChange: (value) => setFilterRequestStatus(value),
                },
                {
                  type: "filter",
                  name: "rating",
                  placeholder: requests.listRequests.rating,
                  value: filterRating,
                  options: ratingOptions,
                  isOptionsElt: true,
                  onChange: (value) => setFilterRating(value),
                },
                {
                  type: "filter",
                  name: "gender",
                  placeholder: events.viewEvents.applicantsTab.gender,
                  value: filterGender,
                  options: genderOptions,
                  onChange: (value) => setFilterGender(value),
                },
                {
                  type: "filter",
                  name: "role",
                  placeholder: events.viewEvents.applicantsTab.role,
                  value: filterRoles,
                  options: roles,
                  onChange: (value) => setFilterRoles(value),
                },
                {
                  type: "filter",
                  name: "city",
                  placeholder: requests.listRequests.cityOfResidence,
                  value: filterCities,
                  options: cities,
                  onChange: (value) => setFilterCities(value),
                },
              ]
        }
      />
      <div className="d-flex flex-column justify-content-between">
        {renderRequestsList()}
      </div>
    </div>
  );
};

export default InviteApplicants;
